export default __webpack_public_path__ + "static/media/Nakul.0c73cdb0.JPG";